import Layout from '../components/layout/index.vue';

export default [
  {
    path: '/',
    name: 'index',
    component: () => import(/* webpackChunkName: "index" */ '../views/home1.vue')
  },
  {
    path: '/signin',
    name: 'signin',
    component: () => import(/* webpackChunkName: "signin" */ '../views/signin.vue')
  },
  {
    path: '/config',
    name: 'config',
    component: () => import(/* webpackChunkName: "config" */ '../views/config.vue')
  },
  {
    path: '/home',
    name: 'home',
    redirect: '/home/dashboard',
    component: Layout,
    children: [
      {
        path: 'dashboard',
        component: () => import(/* webpackChunkName: "home" */ '../views/home/index.vue'),
        name: 'dashboard'
      }
    ],
    meta: { title: '首页' }
  },
  {
    path: '/order',
    name: 'order',
    component: Layout,
    redirect: '/order/list',
    meta: { title: '订单列表' },
    children: [
      {
        path: 'list',
        meta: { title: '全部订单' },
        name: 'order-list',
        component: () => import(/* webpackChunkName: "order-index" */ '../views/order/list')
      },
      {
        path: 'refund',
        meta: { title: '退款维权' },
        name: 'order-refund',
        component: () => import(/* webpackChunkName: "order-refund" */ '../views/order/refund/index.vue')
      },
      {
        path: 'detail',
        meta: { title: '订单详情' },
        name: 'order-detail',
        component: () => import(/* webpackChunkName: "order-detail" */ '../views/order/detail')
      },
      {
        path: 'face',
        meta: { title: '当面付' },
        name: 'order-face',
        component: () => import(/* webpackChunkName: "faceorder-list" */ '../views/order/face/index.vue')
      }
    ]
  },
  {
    path: '/products',
    name: 'products',
    component: Layout,
    redirect: { name: 'products-list' },
    meta: { title: '商品信息' },
    children: [
      {
        path: 'list',
        meta: { title: '商品管理' },
        name: 'products-list',
        component: () => import(/* webpackChunkName: "products-list" */ '../views/products/list')
      },
      {
        path: 'edit',
        meta: { title: '商品详情' },
        name: 'products-edit',
        component: () => import(/* webpackChunkName: "products-edit" */ '../views/products/edit')
      }
    ]
  },
  {
    path: '/subscription',
    name: 'subscription',
    component: Layout,
    redirect: { name: 'subscription-list' },
    meta: { title: '周期购' },
    children: [
      {
        path: 'list',
        meta: { title: '周期购列表' },
        name: 'subscription-list',
        component: () => import(/* webpackChunkName: "subscription-list" */ '../views/subscription/list/index.vue')
      },
      {
        path: 'edit',
        meta: { title: '周期购编辑' },
        name: 'subscription-edit',
        component: () => import(/* webpackChunkName: "subscription-edit" */ '../views/subscription/edit')
      }
    ]
  },
  {
    path: '/category',
    name: 'category',
    component: Layout,
    redirect: { name: 'category-list' },
    meta: { title: '类目管理' },
    children: [
      {
        path: 'list',
        name: 'category-list',
        component: () => import(/* webpackChunkName: "category" */ '../views/category/index.vue')
      }
    ]
  },
  {
    path: '/course',
    name: 'course',
    component: Layout,
    redirect: { name: 'course-list' },
    meta: { title: '开课报名' },
    children: [
      {
        path: 'list',
        meta: { title: '课程列表' },
        name: 'course-list',
        component: () => import(/* webpackChunkName: "course-list" */ '../views/course/list/index.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑课程' },
        name: 'course-edit',
        component: () => import(/* webpackChunkName: "course-edit" */ '../views/course/edit.vue')
      },
      {
        path: 'records',
        meta: { title: '报名记录' },
        name: 'course-records',
        component: () => import(/* webpackChunkName: "course-records" */ '../views/course/records/index.vue')
      }
    ]
  },
  {
    path: '/reservation',
    name: 'reservation',
    component: Layout,
    redirect: '/reservation/list',
    meta: { title: '预约管理' },
    children: [
      {
        path: 'list',
        name: 'reservation-list',
        component: () => import(/* webpackChunkName: "reservation-list" */ '../views/reservation/list')
      }
    ]
  },
  {
    name: 'statistics',
    path: '/statistics',
    component: Layout,
    redirect: '/statistics/dashboard',
    meta: { title: '数据分析' },
    children: [
      {
        path: 'dashboard',
        meta: { title: '经营分析' },
        name: 'statistics-dashboard',
        component: () => import(/* webpackChunkName: "statistics-dashboard" */ '../views/statistics/dashboard/index.vue')
      },
      {
        path: 'miniprogram',
        meta: { title: '小程序分析' },
        name: 'statistics-miniprogram',
        component: () => import(/* webpackChunkName: "statistics-miniprogram" */ '../views/statistics/miniprogram')
      }
    ]
  },
  {
    path: '/marketing',
    name: 'marketing',
    component: Layout,
    redirect: '/marketing/list',
    meta: { title: '营销相关' },
    children: [
      {
        path: 'coupon',
        meta: { title: '优惠券' },
        name: 'marketing-coupon',
        component: () => import(/* webpackChunkName: "marketing-coupon" */ '../views/marketing/coupon/index.vue')
      },
      {
        path: 'coupon-template',
        meta: { title: '优惠券模板' },
        name: 'marketing-coupon-template',
        component: () => import(/* webpackChunkName: "marketing-coupontemp" */ '../views/marketing/coupon-template')
      },
      {
        path: 'coupon-template-edit',
        meta: { title: '编辑优惠券模板' },
        name: 'marketing-coupon-template-edit',
        component: () => import(/* webpackChunkName: "marketing-couponedit" */ '../views/marketing/coupon-template-edit')
      },
      {
        path: 'coupon-template-detail',
        meta: { title: '优惠券模板详情' },
        name: 'marketing-coupon-template-detail',
        component: () => import(/* webpackChunkName: "marketing-coupontempdetail" */ '../views/marketing/coupon-template-detail')
      },
      {
        path: 'coupon-detail',
        meta: { title: '优惠券详情' },
        name: 'marketing-coupon-detail',
        component: () => import(/* webpackChunkName: "marketing-coupondetail" */ '../views/marketing/coupon-detail')
      },
      {
        path: 'list',
        meta: { title: '营销规则' },
        name: 'marketing-list',
        component: () => import(/* webpackChunkName: "marketing-list" */ '../views/marketing/list')
      },
      {
        path: 'edit',
        meta: { title: '编辑营销规则' },
        name: 'marketing-edit',
        component: () => import(/* webpackChunkName: "marketing-edit" */ '../views/marketing/edit')
      },
      {
        path: 'detail',
        meta: { title: '营销规则详情' },
        name: 'marketing-detail',
        component: () => import(/* webpackChunkName: "marketing-detail" */ '../views/marketing/detail')
      },
      {
        path: 'banner',
        meta: { title: '轮播图设置' },
        name: 'marketing-banner',
        component: () => import(/* webpackChunkName: "marketing-banner" */ '../views/marketing/banner/index.vue')
      }
    ]
  },
  {
    name: 'member',
    path: '/member',
    component: Layout,
    meta: { title: '会员储值' },
    children: [
      {
        path: 'storeValueRule',
        meta: { title: '储值规则' },
        name: 'member-storeValueRule',
        component: () => import(/* webpackChunkName: "member-storeValueRule" */ '../views/member/storeValueRule/index.vue')
      },
      {
        path: 'storeValueRecords',
        meta: { title: '储值记录' },
        name: 'member-storeValueRecords',
        component: () => import(/* webpackChunkName: "member-storeValueRecords" */ '../views/member/storeValueRecords/index.vue')
      }
    ]
  },
  {
    name: 'custom',
    path: '/custom',
    component: Layout,
    redirect: '/custom/list',
    meta: { title: '用户管理' },
    children: [
      {
        path: 'list',
        name: 'custom-list',
        component: () => import(/* webpackChunkName: "custom-list" */ '../views/customer/list/index.vue')
      }
    ]
  },
  {
    name: 'setting',
    path: '/setting',
    component: Layout,
    redirect: '/setting/template',
    meta: { title: '设置' },
    children: [
      {
        path: 'shipping',
        meta: { title: '配送设置' },
        name: 'setting-shipping',
        component: () => import(/* webpackChunkName: "setting-shipping" */ '../views/setting/shipping/index.vue')
      },
      {
        path: 'pickup',
        meta: { title: '自提' },
        name: 'setting-pickup',
        component: () => import(/* webpackChunkName: "setting-pickup" */ '../views/setting/pickup/index.vue')
      },
      {
        path: 'employee',
        meta: { title: '管理员' },
        name: 'setting-employee',
        component: () => import(/* webpackChunkName: "setting-employee" */ '../views/setting/employee.vue')
      },
      {
        path: 'employee_edit',
        meta: { title: '编辑人员信息' },
        name: 'setting-employee-edit',
        component: () => import(/* webpackChunkName: "setting-employee-edit" */ '../views/setting/employee_edit.vue')
      },
      {
        path: 'roles',
        meta: { title: '角色管理' },
        name: 'setting-roles',
        component: () => import(/* webpackChunkName: "setting-roles" */ '../views/setting/roles.vue')
      },
      {
        path: 'role_edit',
        meta: { title: '编辑角色信息' },
        name: 'setting-role-edit',
        component: () => import(/* webpackChunkName: "setting-role-edit" */ '../views/setting/role_edit.vue')
      },
      {
        path: 'shopinfo',
        meta: { title: '店铺信息' },
        name: 'setting-shopinfo',
        component: () => import(/* webpackChunkName: "setting-shopinfo" */ '../views/setting/shopinfo/index.vue')
      },
      {
        path: 'minqr',
        meta: { title: '小程序码管理' },
        name: 'setting-minqr',
        component: () => import(/* webpackChunkName: "setting-minqr" */ '../views/setting/minqr/index.vue')
      },
      {
        path: 'options',
        meta: { title: '其他配置项' },
        name: 'setting-options',
        component: () => import(/* webpackChunkName: "setting-options" */ '../views/setting/options.vue')
      },
      {
        path: 'teacher',
        meta: { title: '明星讲师' },
        name: 'setting-teacher',
        component: () => import(/* webpackChunkName: "setting-teacher" */ '../views/setting/teacher.vue')
      },
      {
        path: 'student',
        meta: { title: '明星学员' },
        name: 'setting-student',
        component: () => import(/* webpackChunkName: "setting-student" */ '../views/setting/student.vue')
      },
      {
        path: 'printer',
        meta: { title: '打印' },
        name: 'setting-printer',
        component: () => import(/* webpackChunkName: "setting-printer" */ '../views/setting/printer/index.vue')
      }
    ]
  },
  {
    path: '/store',
    component: Layout,
    children: [
      {
        meta: { title: '小程序链接' },
        path: 'link',
        name: 'link',
        component: () => import(/* webpackChunkName: "link" */ '../views/link/index.vue')
      },
      {
        meta: { title: '分销设置' },
        path: 'profitsharing',
        name: 'profitsharing',
        component: () => import(/* webpackChunkName: "profitsharing" */ '../views/profitsharing/index.vue')
      },
      {
        meta: { title: '分店管理' },
        path: 'branchstore',
        name: 'branchstore',
        component: () => import(/* webpackChunkName: "branchstore" */ '../views/branchstore/index.vue')
      },
      {
        meta: { title: '配送费' },
        path: 'shippingfee',
        name: 'shippingfee',
        component: () => import(/* webpackChunkName: "shippingfee" */ '../views/shippingfee.vue')
      }
    ]
  },
  {
    path: '*',
    name: 'notFound',
    component: () => import(/* webpackChunkName: "home" */ '../views/404.vue')
  }
];
